module.exports = __webpack_public_path__ + "img/d.813cf0a3.svg";